import * as yup from "yup";

const ResetPasswordPageValidation = yup.object().shape({
	email: yup
		.string()
		.email("Lütfen geçerli bir e-posta adresi giriniz.")
		.required("E-posta adresi boş bırakılamaz."),
	password: yup.string().required("Lütfen parolayı giriniz."),
	passwordConfirm: yup
		.string()
		.required("Lütfen parolayı tekrar giriniz.")
		.oneOf([yup.ref("password")], "Parolalar uyumsuz kontrol ediniz."),
});

export default ResetPasswordPageValidation;
